import { AccordionItem, List, Stack, Text } from 'braid-design-system';
export const SeekApiProhibitions = () => (
  <AccordionItem id="seek-api-prohibitions" label="SEEK API Prohibitions">
    <List type="number" start={19}>
      <Stack space="medium">
        <Text>You must not:</Text>
        <List type="alpha">
          <Text>
            require a Candidate to provide any of their details to you,
            including Personal Information or otherwise create an account with
            you, as a precondition to you passing on Data in respect of that
            Candidate to a Mutual Customer;
          </Text>
          <Text>sub-license the SEEK API for use by a third party;</Text>
          <Text>
            perform any action of introducing any viruses, worms, defects,
            Trojan horses, malware or any items of a destructive nature to the
            SEEK APIs;
          </Text>
          <Text>
            interfere with or disrupt the SEEK API or the servers or networks
            providing the SEEK API; or
          </Text>
          <Text>
            reverse engineer or attempt to extract the source code from the SEEK
            API or any related software, except to the extent that this
            restriction is expressly prohibited by applicable law.
          </Text>
        </List>
      </Stack>
    </List>
  </AccordionItem>
);
